import Vue from 'vue'
import Vuex from 'vuex'

// Store

import { modules } from './Store/modules'
import global from './Store/global'

Vue.use(Vuex)

const storeJs = {
	modules,
	...global
}

const store = new Vuex.Store(storeJs)

// Router

import Router from 'vue-router'
import routes from './Routes/routes'

Vue.use(Router)

const router = new Router({
	mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
	if (localStorage.getItem('token')) {
		if (to.path === '/login' || to.path === '/') {
			next({name:'users'})
		} else {
			if (to.path != store.state.toolbar.path) {
				store.commit('cleanToolbar')
			}
			if (!to.meta.extraSidebar) {
				store.commit('setExtraSidebar', {sidebarDrawer: false, compSidebar: null})
			}
			next()
		}
	} else {
		if (to.path === '/login' || to.path === '/') {
			next()
		} else {
			next('/login')
		}	
	}
})

export { store, router }
